module.exports = __webpack_public_path__ + "static/media/logocds-simbolo.f44f317f.svg";